import { useRegistryScript } from "#nuxt-scripts/utils";
export function useScriptCloudflareTurnstile(userOptions) {
  return useRegistryScript("cloudflareTurnstile", () => ({
    scriptInput: {
      src: "https://challenges.cloudflare.com/turnstile/v0/api.js"
    },
    scriptOptions: {
      use: () => window.turnstile
    }
  }), userOptions);
}
